import { GoogleGenerativeAI, SchemaType } from "@google/generative-ai";
import { useRef } from "react";

const useGeneratorV2 = () => {
  const apiKey = "AIzaSyDB2TRX7tEkCcOdDPe-CAneiPH1cxXXzaQ ";
  const genAI = new GoogleGenerativeAI(apiKey);
  const modelType = "gemini-2.0-flash";
  // const schema = {
  //   description: "The response schema for the generated questions.",
  //   type: SchemaType.ARRAY,
  //   items: {
  //     type: SchemaType.OBJECT,
  //     properties: {
  //       interest: {
  //         type: SchemaType.STRING,
  //         description: "The topic or skill area the question is related to.",
  //       },
  //       questions: {
  //         type: SchemaType.ARRAY,
  //         description: "An array of MCQ problems.",
  //         items: {
  //           type: SchemaType.OBJECT,
  //           properties: {
  //             question: {
  //               type: SchemaType.STRING,
  //               description: "The MCQ problem statement.",
  //             },
  //             options: {
  //               type: SchemaType.ARRAY,
  //               items: {
  //                 type: SchemaType.STRING,
  //               },
  //               minItems: 4,
  //               maxItems: 4,
  //               description:
  //                 "An array of exactly four possible answer choices.",
  //             },
  //             correct_answer: {
  //               type: SchemaType.INTEGER,
  //               description: "The correct option index (0-based).",
  //             },
  //             question_type: {
  //               type: SchemaType.STRING,
  //               enum: ["single-choice"],
  //               description: "Defines the type of MCQ question.",
  //             },
  //           },
  //           required: ["question", "options", "correct_answer"],
  //         },
  //       },
  //     },
  //     required: ["interest", "questions"],
  //   },
  // };

  const schema = {
    description: "The response schema for the generated question.",
    type: SchemaType.OBJECT,
    properties: {
      interest: {
        type: SchemaType.STRING,
        description: "The topic or skill area the question is related to.",
      },
      question: {
        type: SchemaType.STRING,
        description: "The MCQ problem statement.",
      },
      options: {
        type: SchemaType.ARRAY,
        items: {
          type: SchemaType.STRING,
        },
        minItems: 4,
        maxItems: 4,
        description: "An array of exactly four possible answer choices.",
      },
      correct_answer: {
        type: SchemaType.INTEGER,
        description: "The correct option index (0-based).",
      },
    },
    required: ["interest", "question", "options", "correct_answer"],
  };
  const generationConfig = {
    temperature: 0.2,
    topP: 0.9,
    topK: 64,
    maxOutputTokens: 1024,
    responseMimeType: "application/json",
    responseSchema: schema,
  };
  //   const systemPrompt = `You are an curriculum experts which generates new MCQs based on user input.
  //   - Inputs: board(B), country(R), language(L), grade(G), interests(I), and number of MCQs(Q).
  //   - Each MCQ must have 4 options, 1 correct answer (0-based index), and be single-choice.
  //   - Consider adopting the persona of an experienced educator when formulating the questions.
  //   - Focus on testing understanding and application of concepts rather than simple recall.
  // `

  const systemPrompt = `Generate MCQs based on: board(B), country(R), language(L), grade(G), interests(I). Each MCQ has 4 options, 1 correct answer (0-based), and is single-choice. Focus on concepts over recall. Don't repeat questions`;

  const chatSessionRef = useRef(null); // to store the chat session
  const model = genAI.getGenerativeModel({
    model: modelType,
    systemInstruction: systemPrompt,
    generationConfig,
  });

  const sampleQuestionsArray = [
    {
      interest: "Leadership",
      problem: "What is the most important quality of a leader?",
      options: [
        "Being the loudest person in the room",
        "Being able to listen to others and make fair decisions",
        "Knowing all the answers",
        "Always being in charge",
      ],
      correct_answer: "2",
    },
    {
      interest: "Organisational",
      problem: "Why is it important to organize your school bag?",
      options: [
        "To make it heavier",
        "To make it look nice",
        "To find things quickly and easily",
        "So other people can see your things",
      ],
      correct_answer: "3",
    },
    {
      interest: "Active listening",
      problem:
        "While someone is talking, what's a good way to show you're listening?",
      options: [
        "Looking at your phone",
        "Nodding and making eye contact",
        "Interrupting to share your own story",
        "Ignoring them",
      ],
      correct_answer: "2",
    },
    {
      interest: "Analytical thinking",
      problem:
        "You have a puzzle with many pieces. What is a good first step to solving it?",
      options: [
        "Start putting random pieces together",
        "Look at the picture on the box to understand the final image",
        "Give up if it looks too hard",
        "Ask someone else to solve it for you",
      ],
      correct_answer: "2",
    },
    {
      interest: "Artificial Intelligence",
      problem: "What is Artificial Intelligence (AI)?",
      options: [
        "A type of robot that looks like a human",
        "A type of car that drives itself",
        "A computer program that can do things that normally require human intelligence",
        "A video game character",
      ],
      correct_answer: "3",
    },
  ];

  const questionRelevance = useRef(null);

  // Starting a new session
  const startChat = async () => {
    chatSessionRef.current = null;
    chatSessionRef.current = await model.startChat();
  };

  // Check if the question relevance has changed
  const hasChanges = (arr1, arr2) => {
    return arr1.some((_, i) => {
      return arr1[i] !== arr2[i];
    });
  };

  // Generate questions based on the relevance
  const generateQuestionsV2 = async (relevance) => {
    let isChanged =
      questionRelevance.current === null
        ? true
        : hasChanges(questionRelevance.current.interests, relevance.interests);
    console.log("isChanged", relevance, questionRelevance.current);

    if (!chatSessionRef.current || isChanged) {
      console.log("Starting chat");
      await startChat();
    }

    if (isChanged) {
      questionRelevance.current = relevance;
    }

    let { interests, grade, board, region, language, numberOfQuestions } =
      questionRelevance.current;
    let historyLength = await chatSessionRef.current._history.length;
    let prompt = "new question";
    if (historyLength <= 0) {
      let questionsObj = localStorage.getItem("excludedQV1")
        ? JSON.parse(localStorage.getItem("excludedQV1"))
        : {};

      let questions = questionsObj[interests[0]] || [];
      console.log("questions", questions, questionsObj);
      let latestAskedQuestion = questions.slice(-5);
      console.log("latestAskedQuestion", latestAskedQuestion);
      prompt = `I:${interests.join(
        "|"
      )},B:${board},R:${region},G:${grade},L:${language}. don't repeat question, Respond with minified JSON (no line breaks, indentation)`;
    }

    console.log("Prompt", prompt);
    const result = await chatSessionRef.current.sendMessage(prompt);
    const questions = result.response.text();
    const parsedQuestions = JSON.parse(questions);
    console.log("parsedQuestions", parsedQuestions);

    return parsedQuestions;
  };

  // Generate questions based on the relevance
  const generateQuestions = async (relevance) => {
    let isChanged =
      questionRelevance.current === null
        ? true
        : hasChanges(questionRelevance.current.interests, relevance.interests);
    console.log("isChanged", relevance, questionRelevance.current);

    if (!chatSessionRef.current || isChanged) {
      console.log("Starting chat");
      await startChat();
    }

    if (isChanged) {
      questionRelevance.current = relevance;
    }

    let { interests, grade, board, region, language, numberOfQuestions } =
      questionRelevance.current;
      let questionsObj = localStorage.getItem("excludedQ")
        ? JSON.parse(localStorage.getItem("excludedQ"))
        : {};

      let questions = questionsObj || [];
      console.log("questions", questions, questionsObj);
      let latestAskedQuestion = questions.slice(-5);
      console.log("latestAskedQuestion", latestAskedQuestion);
      prompt = `I:${interests.join(
        "|"
      )},B:${board},R:${region},G:${grade},L:${language}, Q:${numberOfQuestions}. don't repeat previously generated questions: ${ latestAskedQuestion.join("|") }`;


    console.log("Prompt", prompt);
    const result = await chatSessionRef.current.sendMessage(prompt);
    const question = result.response.text();
    const parsedQuestions = JSON.parse(question);
    console.log("parsedQuestions", parsedQuestions);

    return parsedQuestions;
  };


  return {
    generateQuestions,
    generateQuestionsV2,
    model,
    chatSessionRef
  };
};

export default useGeneratorV2;
